<template>
    <kt-panel-body>
        <kt-panel>
            <div style="margin-top: 20px;margin-bottom: 50px" class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed" data-toggle="collapse"
                     data-target="#filterForm"
                     aria-controls="filterForm">
                    {{ $t('label.list_admin_for_sending_settlement_notifications') }}
                </div>
            </div>

            <form @submit.prevent="submit()" id="form_data">
                <div class="custom-control custom-checkbox mb-3" style="margin-right: 10px;">
                    <input type="checkbox" v-model="admin_phones.send_notification_status" class="custom-control-input" id="be_send">
                    <label for="be_send" class="custom-control-label">{{$t('label.send_notification_status')}}</label>
                </div>
                <div class="row p-2" v-for="(item, index) in admin_phones.payload" :key="index">
                    <div class="col-md-5">
                        <div class="form-group">
                            <label :for="'full_name' + index">{{ $t('label.full_name') }}</label>
                            <input v-model="item.full_name" :id="'full_name' + index" :name="'full_name' + index"
                                   type="text" class="form-control">
                            <div :data-id="'full_name' + index" class="error invalid-feedback" style="display: none;">
                                {{ $t('validation.required') }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="form-group">
                            <label :for="'phone' + index">{{ $t('label.phone_number') }}</label>
                            <input v-model="item.phone" type="text" :id="'phone' + index" :name="'phone' + index"
                                   class="form-control">
                            <div :data-id="'phone' + index" class="error invalid-feedback" style="display: none;">
                                {{ $t('validation.required') }}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-1">
                        <div class="mt-4 p-2 text-center">

                            <button type="button"
                                    v-if="admin_phones.payload.length -1 !== index || admin_phones.payload.length -1 === index && index >= 1"
                                    @click="popData(index)"
                                    class="btn btn-outline-danger btn-sm ml-1  btn-icon">
                                <i class="fa fa-trash fa-x4"></i>
                            </button>
                        </div>
                    </div>

                </div>
                <div class="m-2 ">
                    <button type="button" @click="pushData"
                            class="btn btn-info  mr-1">
                        {{ $t('btn.add') }}
                    </button>
                </div>
                <div class="row m-2 justify-content-end">
                    <button class="btn btn-success"
                            data-toggle="modal" :disabled="status === 'loading'" data-target="#exampleModal">
                        <span v-if="status === 'loading'" class="spinner-border spinner-border-sm"></span>
                        <span v-else>{{ $t('btn.submit') }}</span>
                    </button>
                </div>
            </form>
        </kt-panel>
    </kt-panel-body>
</template>

<script>
import Datatable from "../../../components/elements/datatable.vue";
import Label from "../../../components/elements/form/label.vue";
import Form from "../../pardakhtShakhsi/components/form.vue";
import $ from 'jquery'
import {mapGetters} from "vuex";
import toastr from "toastr";
import Input from "../../../components/elements/input.vue";

export default {
    name: "AdminPhones",
    components: {Input, Form, Label, Datatable},
    data() {
        return {
            be_send: false,
        }
    },
    mounted() {
        this.fetchAdminPhones();
    },

    methods: {
        fetchAdminPhones() {
            this.$store.dispatch('settlement/fetchAdminPhones')
        },
        pushData() {
            this.admin_phones.payload.push({
                full_name: null,
                phone: null
            })
        },
        popData(index) {
            this.admin_phones.payload.splice(index, 1);
            $(`div[data-id=phone${index}]`).hide()
            $(`div[data-id=full_name${index}]`).hide()
        },
        async submit() {
            let data = [];
            let status = false;
            this.admin_phones.payload.map((item, index) => {

                $(`div[data-id=phone${index}]`).hide()
                $(`div[data-id=full_name${index}]`).hide()

                if (item.full_name != null && item.phone != null && item.full_name !== "" && item.phone !== "") {
                    data.push(item)
                } else {
                    if (item.phone === null || item.phone === "") {
                        status = true;
                        $(`div[data-id=phone${index}]`).show()
                    }

                    if (item.full_name === null || item.full_name === "") {
                        $(`div[data-id=full_name${index}]`).show()
                        status = true
                    }

                }

            })

            if (data.length === 0 || status)
                return;

            data.be_send = !!this.admin_phones.be_send

            await this.$store.dispatch('settlement/createAdminPhone', {payload: data, send_notification_status: this.admin_phones.send_notification_status})
            this.toastr.success(this.$t('settlement_request_status.done'))
            this.fetchAdminPhones();
        },
    },
    computed: {
        ...mapGetters('settlement', ['admin_phones', 'status']),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false,
            };

            return toastr;
        },
    }
}
</script>

<style scoped>

</style>